// frontend/src/components/TestPage.js
import React, { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

const API = "https://css-67zw.onrender.com";

export default function TestPage() {
  const { user } = useAuth();
  const navigate = useNavigate();

  const [mcqs, setMcqs] = useState([]);
  const [current, setCurrent] = useState(0);
  const [answers, setAnswers] = useState({});
  const [loading, setLoading] = useState(true);

  /* LOAD QUESTIONS */
  useEffect(() => {
    axios
      .get(`${API}/api/mcqs`)
      .then((res) => {
        setMcqs(res.data || []);
        setLoading(false);
      })
      .catch((err) => {
        console.error(err);
        setLoading(false);
      });
  }, []);

  if (loading) return <p className="container">Loading...</p>;
  if (!mcqs.length) return <p className="container">No questions found.</p>;

  /* SELECT ANSWER */
  const selectOption = (index) => {
    setAnswers((prev) => ({ ...prev, [current]: index }));
  };

  /* SUBMIT TEST */
  const submitTest = async () => {
    let score = 0;
    const wrongAnswers = [];

    mcqs.forEach((q, i) => {
      const selected = answers[i];
      const correctIndex = q.correctIndex;

      if (selected === correctIndex) {
        score++;
      } else {
        wrongAnswers.push({
          questionId: q._id,
          questionText: q.question,
          options: q.options,
          selectedIndex:
            typeof selected === "number" ? selected : null,
          selectedText:
            typeof selected === "number"
              ? q.options[selected]
              : "Not Answered",
          correctIndex,
          correctText: q.options[correctIndex],
          subject: q.subject,
        });
      }
    });

    const resultData = {
      name: user?.email || "Guest",
      userId: user?._id || null,
      score,
      total: mcqs.length,
      wrongAnswers,
      questionIds: mcqs.map((q) => q._id),
    };

    try {
      await axios.post(`${API}/api/results`, resultData, {
        withCredentials: true,
      });

      // ✅ PASS RESULT TO RESULT PAGE
      navigate("/result", {
        state: { result: resultData },
      });
    } catch (err) {
      console.error(err);
      alert("Failed to submit test");
    }
  };

  const q = mcqs[current];

  return (
    <div className="container">
      <h2>Practice Test</h2>
      <p>
        Question {current + 1} of {mcqs.length}
      </p>

      <div className="mcq-card">
        <h3>{q.question}</h3>

        {q.options.map((opt, i) => (
          <div
            key={i}
            className={`mcq-option ${
              answers[current] === i ? "correct" : ""
            }`}
            onClick={() => selectOption(i)}
          >
            {String.fromCharCode(65 + i)}. {opt}
          </div>
        ))}
      </div>

      <div style={{ marginTop: 20 }}>
        {current > 0 && (
          <button
            className="btn"
            onClick={() => setCurrent((c) => c - 1)}
          >
            Previous
          </button>
        )}

        {current < mcqs.length - 1 ? (
          <button
            className="btn"
            onClick={() => setCurrent((c) => c + 1)}
          >
            Next
          </button>
        ) : (
          <button className="btn" onClick={submitTest}>
            Submit Test
          </button>
        )}
      </div>
    </div>
  );
}
